import styled from 'styled-components'
import { motion } from 'framer-motion'

export const Container = styled(motion.div)`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.6); // fundo escuro translúcido
  display: flex;
  justify-content: center;
  align-items: flex-end;
  `

export const Drawer = styled(motion.div)`
  width: 100%;
  max-width: 480px;
  background-color: ${({ theme }) => theme.colors.background || '#fff'};
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  padding-top: 0.75rem;
  box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  max-height: 90dvh;
  overflow-y: auto;
  padding-bottom: 16px;
`

export const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1.5rem;
`

export const DragHandle = styled.button`
  height: 0.4rem;
  width: 3rem;
  border-radius: 9999px;
  background-color: rgba(160, 160, 160, 0.6);
  border: none;
  margin-bottom: 1rem;
  pointer-events: none;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 16px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: rgba(22, 22, 22, 0.64);
`

export const Content = styled.div`
  padding: 0 0 2rem;
  display: flex;
  flex-direction: column;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 16px;
`

export const Title = styled.span`
  font-weight: 700;
  font-size: 24px;
  line-height: 28.8px;
  color: #A14D2A;
  margin-bottom: 1rem;
  margin-top: 1rem;
  margin-left: 24px;
  margin-right: 24px;
`
